namespace GeniuzPOS.Inventory {
    export interface IcStockReturnInDtRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        SkuCode?: string;
        ItemRemark?: string;
        Qty?: number;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        CostValue?: number;
        ExpDate?: string;
        Remark?: string;
        StkQty?: number;
        GRRefFg?: string;
        GRLineId?: number;
    }

    export namespace IcStockReturnInDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockReturnInDt';
        export const deletePermission = '2Inventory:รายการ:รับคืน:Modify';
        export const insertPermission = '2Inventory:รายการ:รับคืน:Modify';
        export const readPermission = '2Inventory:รายการ:รับคืน:View';
        export const updatePermission = '2Inventory:รายการ:รับคืน:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            ItemRemark = "ItemRemark",
            Qty = "Qty",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            CostValue = "CostValue",
            ExpDate = "ExpDate",
            Remark = "Remark",
            StkQty = "StkQty",
            GRRefFg = "GRRefFg",
            GRLineId = "GRLineId"
        }
    }
}
